import { getIsForward } from 'conversations-message-history/common-message-format/operators/emailMetadataGetters';
import { ForwardIcon, ReplyAllIcon, ReplyIcon } from 'foundations-assets';
export const getRecipientsIconName = ({
  allRecipients,
  commonMessageReply,
  replyAll
}) => {
  const allRecipientsValue = allRecipients && allRecipients.getIn(['all']);
  const hasMultipleRecipients = replyAll && allRecipientsValue && allRecipientsValue.size > 1;
  const isForward = commonMessageReply && getIsForward(commonMessageReply);
  return isForward ? {
    icon: ForwardIcon,
    name: 'forward'
  } : hasMultipleRecipients ? {
    icon: ReplyAllIcon,
    name: 'replyAll'
  } : {
    icon: ReplyIcon,
    name: 'reply'
  };
};